export const TERMS_OF_SERVICE = `GGP (Global Green Platform) 이용약관

제1조 목적
본 약관은 GGP가 제공하는 서비스의 이용에 관한 조건 및 절차, 이용자와 회사의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 용어의 정의
1. "회사"란 GGP 서비스를 제공하는 법인을 의미합니다.
2. "이용자"란 본 약관에 동의하여 회사가 제공하는 서비스를 받는 개인 또는 단체를 의미합니다.
3. "서비스"란 회사가 제공하는 모든 온라인 및 모바일 기반 서비스를 의미합니다.

제3조 약관의 게시와 변경
1. 회사는 본 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.
2. 회사는 관련법을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.
3. 회사가 약관을 변경할 경우, 변경된 약관은 30일 이상 공지합니다.

제4조 이용 신청
1. 이용자는 회사가 정한 양식에 따라 회원가입을 신청합니다.
2. 회사는 이용자의 신청에 대하여 승인하거나 거절할 수 있습니다.

제5조 이용자의 의무
1. 이용자는 관련 법령을 준수하며 본 약관에 동의합니다.
2. 이용자는 서비스 이용 중 발생하는 모든 책임을 집니다.
3. 이용자는 타인의 정보를 도용하거나 부정한 목적으로 서비스를 이용할 수 없습니다.

제6조 서비스의 제공 및 변경
1. 회사는 24시간, 년중무휴 서비스를 제공하는 것을 원칙으로 합니다.
2. 회사는 정기점검, 장애, 천재지변 등의 이유로 서비스 제공을 중단할 수 있습니다.

제7조 책임의 제한
회사는 이용자가 서비스 이용으로 발생한 손해에 대해 책임을 지지 않습니다.

제8조 서비스 이용의 종료
이용자 또는 회사는 언제든지 서비스 이용을 중단할 수 있습니다.

제9조 기타사항
본 약관에 명시되지 않은 사항은 관련 법령에 따릅니다.`;

export const PRIVACY_POLICY = `개인정보 수집 및 이용 안내

1. 수집하는 개인정보 항목
회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.
- 필수항목: 이메일, 이름, 비밀번호, 성별, 주소
- 선택항목: 휴대폰번호, 프로필 사진

2. 수집 및 이용 목적
수집된 개인정보는 다음의 목적을 위해 이용됩니다.
- 회원가입 및 회원관리
- 서비스 제공 및 콘텐츠 전달
- 이용자 식별 및 인증
- 고객지원 및 불만처리
- 서비스 개선 및 통계분석
- 보안 및 부정거래 방지

3. 개인정보의 보유 및 이용 기간
- 회원탈퇴 요청 시 즉시 삭제
- 단, 관련 법령에 따라 별도의 보관 의무가 있는 경우 해당 기간 보관

4. 개인정보의 안전성 확보
회사는 개인정보를 안전하게 관리하기 위해 다음과 같은 기술적, 관리적 대책을 실시합니다.
- SSL 암호화 통신
- 비밀번호 암호화 저장
- 접근권한 제한
- 정기적인 보안감사

5. 개인정보의 제3자 제공
회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다.
단, 다음의 경우에는 예외로 합니다.
- 이용자의 동의가 있는 경우
- 관련 법령에서 요구하는 경우

6. 이용자의 권리
이용자는 언제든지 개인정보 조회, 수정, 삭제를 요청할 수 있습니다.

7. 정보보호 책임자
개인정보 관련 문의는 support@ggp.com으로 연락주시기 바랍니다.`;

export const MARKETING_POLICY = `마케팅 활용 및 광고 안내

1. 마케팅 정보 제공
본 항목에 동의하시면 회사에서 제공하는 다양한 마케팅 정보를 수신하실 수 있습니다.

2. 제공하는 정보의 유형
- 신규 서비스 및 기능 안내
- 이벤트 및 프로모션 정보
- 맞춤형 추천 정보
- 뉴스레터 및 블로그 소식

3. 정보 제공 방식
- 이메일
- 앱 푸시 알림
- SMS (휴대폰번호 제공 시)
- 인앱 알림

4. 동의 철회
이용자는 언제든지 마케팅 정보 수신을 거절할 수 있습니다.
- 마이페이지 > 알림 설정에서 변경 가능
- 각 이메일 하단의 구독 취소 링크 클릭
- 고객지원 센터로 문의

5. 마케팅 활용 거부 시
마케팅 정보 수신을 거부해도 회사의 필수 서비스 이용에는 영향을 주지 않습니다.

6. 제3자 정보 공유
마케팅 목적으로 개인정보가 제3자와 공유되지 않습니다.

7. 빈도 및 스팸 방지
회사는 과도한 정보 제공으로 인한 피해를 최소화하기 위해 합리적인 빈도로 정보를 제공합니다.`;
